/** Portal Session's private transport adapter. Callers only see Portal Account Scope outcomes. */
export async function readPortalSessionPayload(viewAsPartnerId: string | null): Promise<unknown> {
  const { supabase } = await import('@/lib/supabase');
  const { data, error } = await supabase.rpc('get_partner_portal_session_v2', {
    p_view_as_partner_id: viewAsPartnerId ?? undefined,
  });

  if (error) {
    throw error;
  }

  return data;
}
